import React, { useMemo, useState } from 'react';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import './styles.less';
import classNames from 'classnames';

/**
 * 
 * @param {*} props extends antd Alert item props
 * @param {bool} props.startExpanded initially expand description
 */
const ExpandableAlert = ( props ) => {

    const [ expanded, setExpanded ] = useState( !!props?.startExpanded );
    const description = useMemo( () => {
        if ( props.error ) {
            if ( Array.isArray( props.error ) ) {
                return <ul>
                    { props.error.map( ( e, i ) => <li key={ i }>{ e }</li> ) }
                </ul>;
            }
            let error = props.error.toString();
            if ( error === '[object Object]' && props.error.errorFields ) {
                error = <ul>
                    { props.error.errorFields.map( ( e, i ) => <li key={ i }>{ e.errors.toString() }</li> ) }
                </ul>;
            }
            return error;
        }
        return props.description;
    }, [ props.error, props.description ] );
    const isError = useMemo( () => !!props.error, [ props.error ] );

    return <Alert 
        className={ classNames( { expandable: !!description } ) } 
        type={ isError ? 'error' : 'info' }
        { ...props } 
        message={ <>
            <span>{ props.message }</span>
            { !description ? <></> : expanded ? <CaretUpOutlined /> : <CaretDownOutlined /> }
        </> } 
        description={ expanded ? description : '' } 
        onClick={ () => setExpanded( !expanded ) } 
        />;
};

export default ExpandableAlert;